/**
 * GenerateResponseAction Component
 * Action chip for generating AI responses based on SELECTED MESSAGES
 * ✅ UPDATED: Executes directly on click (no language dropdown)
 * ✅ Auto-detects language from selected messages
 */
import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import { getWorkspaceColors } from '../styles';
import { ACTION_TYPES, ACTIONS_CONFIG } from '../constants';

const GenerateResponseAction = ({ 
  onExecute,
  isProcessing = false,
  isDisabled = false,
  disabledReason = 'Selecione mensagens para gerar resposta',
}) => {
  const { colors, theme } = useTheme();
  const workspaceColors = getWorkspaceColors(colors, theme === 'dark');
  const config = ACTIONS_CONFIG[ACTION_TYPES.GENERATE];

  const handleClick = () => {
    if (isDisabled || isProcessing) return;
    // Execute directly - no dropdown needed
    onExecute?.();
  };

  const chipStyles = {
    button: {
      padding: '10px 18px',
      borderRadius: 24,
      border: 'none',
      backgroundColor: isProcessing 
        ? workspaceColors.bgSecondary
        : isDisabled
          ? workspaceColors.bgSecondary
          : (workspaceColors.chipBg || workspaceColors.bgTertiary),
      color: isProcessing 
        ? workspaceColors.textSecondary
        : isDisabled
          ? workspaceColors.textTertiary
          : workspaceColors.textPrimary,
      cursor: isProcessing || isDisabled ? 'not-allowed' : 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      fontSize: 14,
      fontWeight: 600,
      transition: 'all 0.15s ease',
      opacity: isDisabled ? 0.5 : 1,
    },
    spinner: {
      animation: 'generateActionSpin 1s linear infinite',
    },
  };

  return (
    <>
      <button
        style={chipStyles.button}
        onClick={handleClick}
        disabled={isProcessing || isDisabled}
        title={isDisabled ? disabledReason : 'Gerar resposta baseada nas mensagens selecionadas'}
        onMouseEnter={(e) => {
          if (!isProcessing && !isDisabled) {
            e.currentTarget.style.backgroundColor = workspaceColors.chipHover || workspaceColors.bgSecondary;
          }
        }}
        onMouseLeave={(e) => {
          if (!isProcessing && !isDisabled) {
            e.currentTarget.style.backgroundColor = workspaceColors.chipBg || workspaceColors.bgTertiary;
          }
        }}
      >
        {isProcessing ? (
          <>
            <Loader2 size={18} style={chipStyles.spinner} />
            Gerando...
          </>
        ) : (
          <>
            <Sparkles size={18} />
            {config.label}
          </>
        )}
      </button>

      <style>{`
        @keyframes generateActionSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default GenerateResponseAction;